import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/useTranslation';

const FEATURE_SHORTCUTS = [
  { id: 'about', labelKey: 'homePage.shortcuts.about', icon: 'auto_awesome', link: '/intro', className: 'btn-monotone-2' },
  { id: 'developers', labelKey: 'homePage.shortcuts.developers', icon: 'code', link: 'https://developers.astrantis.net', className: 'btn-monotone-2' },
  { id: 'games', labelKey: 'homePage.shortcuts.games', icon: 'sports_esports', link: '/subproject/games', className: 'btn-monotone-2' },
  { id: 'mindmap', labelKey: 'homePage.shortcuts.mindmap', icon: 'hub', link: '/canvas', className: 'btn-monotone-2' },
  { id: 'synapse', labelKey: 'homePage.shortcuts.synapse', icon: 'schema', link: '/synapse', className: 'btn-monotone-2' },
  { id: 'card-news', labelKey: 'homePage.shortcuts.cardNews', icon: 'view_carousel', link: '/subproject/card-news', className: 'btn-monotone-2' },
  { id: 'mood', labelKey: 'homePage.shortcuts.mood', icon: 'mood', link: '/subproject/mood', className: 'btn-monotone-2' },
  { id: 'ad', labelKey: 'homePage.shortcuts.ad', icon: 'campaign', link: null, className: 'btn-home-feature-ad' },
];

function FeatureShortcut({ item, t }) {
  const label = t(item.labelKey);
  const content = (
    <>
      <span className="material-symbols-rounded" aria-hidden="true">{item.icon}</span>
      <span className="btn-home-feature-label">{label}</span>
      {item.id === 'ad' && <span className="btn-home-feature-ad-badge">{t('homePage.shortcuts.adBadge')}</span>}
    </>
  );

  const classNames = ['btn-home-feature', item.className].filter(Boolean).join(' ');

  if (item.link) {
    const isExternal = /^https?:\/\//.test(item.link);

    if (isExternal) {
      return (
        <a
          href={item.link}
          className={classNames}
          title={label}
          target="_blank"
          rel="noopener noreferrer"
        >
          {content}
        </a>
      );
    }

    return (
      <Link to={item.link} className={classNames} title={label}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={classNames}
      title={item.comingSoon ? t('homePage.shortcuts.comingSoon', { label }) : label}
      disabled
    >
      {content}
    </button>
  );
}

function HomeFeatureShortcuts() {
  const { t } = useTranslation();

  return (
    <div className="btn-home-feature-group">
      {FEATURE_SHORTCUTS.map((item) => (
        <FeatureShortcut key={item.id} item={item} t={t} />
      ))}
    </div>
  );
}

export default HomeFeatureShortcuts;
